import React, { useEffect } from "react";
import PropTypes from "prop-types";
import { AnimatePresence, motion } from "framer-motion";
import { connect } from "react-redux";
import { selectUserState } from "../../selectors/application";
// Components
import PrimaryButton from "../../elements/primary-button";
import SimpleLink from "../../elements/simple-link";
// Styles
import "./style.scss";
// Animations
import {
  containerLoginAnimations,
  childLoginAnimations,
  checkoutAnimations,
} from "./animations";

const LoginPanel = ({
  heading,
  button,
  active,
  user,
  link,
  onClickOutside = () => {},
}) => {
  useEffect(() => {
    var link = document.getElementsByClassName("login-page-my-pages-link")[0];
    var newLink = document.getElementsByClassName(
      "login-page-my-pages-link-overlapping"
    )[0];
    var button = document.getElementsByClassName("login-page-logout")[0];
    var innerElement = document.getElementsByClassName(
      "login-panel-heading"
    )[0];
    if (link && button && innerElement && newLink) {
      var totalWidth = link.clientWidth + button.clientWidth;
      if (totalWidth > innerElement.clientWidth) {
        newLink.style.display = "block";
        link.style.display = "none";
      }
    }
  }, [active]);

  return (
    <AnimatePresence>
      {active && (
        <div className="login-panel-container" onClick={onClickOutside}>
          <motion.div
            className="login-panel"
            variants={containerLoginAnimations}
            initial="exit"
            animate="enter"
            exit="exit"
            onClick={(event) => {
              // Prevent click in cart preview to call onClickOutside
              event.stopPropagation();
            }}
            onTouchStart={(event) => {
              document.querySelector("body").classList.add("no-scroll");
            }}
            onTouchEnd={(event) => {
              document.querySelector("body").classList.remove("no-scroll");
            }}
          >
            <motion.div
              className="animate"
              variants={childLoginAnimations}
              exit="exit"
            >
              <div className="login-panel-heading">{heading}</div>
              <div className="login-panel-user-name">
                {user?.firstName} {user?.lastName}
              </div>
            </motion.div>

            <motion.div
              variants={checkoutAnimations}
              exit="exit"
              className="animate"
            >
              <span className="login-panel-buttons" onClick={onClickOutside}>
                <div className="login-page-logout">
                  <PrimaryButton {...button} />
                </div>
                <div className="login-page-my-pages-link">
                  <SimpleLink {...link} />
                </div>
              </span>
              <div className="login-page-my-pages-link-overlapping">
                <SimpleLink {...link} />
              </div>
            </motion.div>
          </motion.div>
        </div>
      )}
    </AnimatePresence>
  );
};

LoginPanel.propTypes = {
  heading: PropTypes.object,
  button: PropTypes.object,
  link: PropTypes.object,
  active: PropTypes.bool,
  onClickOutside: PropTypes.func,
};

const mapStateToProps = (state) => {
  return {
    user: selectUserState(state),
  };
};

const mapDispatchToProps = (dispatch) => ({});

export default connect(mapStateToProps, mapDispatchToProps)(LoginPanel);
